export default "__VITE_ASSET__DoCSwRS8__"